import React from 'react';
import Spinner, { SpinnerColor } from '../../../generic-components/Spinner';

export const PreLoad = () => (
  <div className='fadeIn w-full h-[95%] flex items-center justify-center rounded-md shadow-light bg-bw00'>
    <Spinner height='2rem' width='2rem' spinnerColor={SpinnerColor.Blue} />
  </div>
);
